import { render, staticRenderFns } from "./ReportFarmerSMSSummaries.vue?vue&type=template&id=20dd88ee&"
import script from "./ReportFarmerSMSSummaries.vue?vue&type=script&lang=js&"
export * from "./ReportFarmerSMSSummaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports